// extracted by mini-css-extract-plugin
module.exports = {"hr":"_2M-AUqQXYaexIjMw"};